import {fromJS, Map} from 'immutable';
import pageActions from '../actions/page.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';

export interface PageState {
    loading: boolean;
    data: Record<string, any>;
}

export const DEFAULT_STATE = fromJS({
    loading: false,
    data: {}
});

export const pageReducer = (state: Map<keyof PageState, any> = DEFAULT_STATE, action) => {
    let newState = state;
    switch (action.type) {
        case pageActions.TYPES.GET_PAGE: {
            newState = newState.updateIn(['loading'], () => true);
            return newState;
        }
        case pageActions.TYPES.GET_PAGE_COMPLETE: {
            const {data = {}} = action.payload || {};
            newState = newState.updateIn(['data'], () => data);
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }
        case pageActions.TYPES.GET_PAGE_FAILED: {
            newState = newState.updateIn(['loading'], () => false);
            return newState;
        }
        default:
            return newState;
    }
};

export default dieselReducer('page', pageReducer);
